import React, { useState, useEffect } from 'react';
import { universityService } from '../../services/universityService';
import { University } from '../../types';
import { useRouter, Link } from '../../router/Router';
import { MultiDayBookingWizard } from '../booking/MultiDayBookingWizard';

export const TripListing: React.FC = () => {
  const { queryParams, navigate } = useRouter();
  const universityId = queryParams.universityId || '';

  const [university, setUniversity] = useState<University | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      if (universityId) {
        const uni = await universityService.getUniversityById(universityId);
        setUniversity(uni);
      } else {
        // If no university chosen, redirect to universities selector
        navigate('/student/universities', { replace: true });
        return;
      }
      setIsLoading(false);
    };

    loadData();
  }, [universityId, navigate]);

  return (
    <div className="booking-page-container" dir="rtl">
      {/* Breadcrumb Header */}
      <div className="booking-page-header">
        <div className="header-breadcrumbs">
          <Link to="/student" className="breadcrumb-link">
            لوحة الطالب
          </Link>
          <span className="breadcrumb-sep">/</span>
          <Link to="/student/universities" className="breadcrumb-link">
            اختيار الجامعة
          </Link>
          <span className="breadcrumb-sep">/</span>
          <span className="breadcrumb-current">حجز الرحلات</span>
        </div>
      </div>

      {isLoading ? (
        <div className="loading-state-card" style={{ padding: '3rem 1rem', textAlign: 'center' }}>
          <div className="loading-spinner"></div>
          <p>جاري تحميل بيانات رحلات الجامعة ومواعيدها...</p>
        </div>
      ) : university ? (
        <MultiDayBookingWizard
          university={university}
          onCancel={() => navigate('/student/universities')}
        />
      ) : null}
    </div>
  );
};
